<template>
    <el-form-item class="mt-6 mb-0" prop="recurrency">
        <el-radio-group v-model="recurrencyPlan">
            <el-tooltip placement="bottom" :disabled="!isSourceSale">
                <template #content>
                    <div>
                        {{ $l10n.__('Pour modifier la fréquence de paiement,') }}<br />
                        {{ $l10n.__('merci de contacter un commercial') }}
                    </div>
                </template>
                <el-radio-button label="MONTHLY" :disabled="isSourceSale">
                    <p class="m-0 px-2">
                        <span class="fs-3 pb-1 semibold block">{{
                            $l10n.__('Payer tous les mois')
                        }}</span>
                        <span class="fs-2 regular block">{{ $l10n.__('Engagement 12 mois') }}</span>
                    </p>
                </el-radio-button>
            </el-tooltip>
            <el-tooltip placement="bottom" :disabled="!disableYearly || !isSourceSale">
                <template #content>
                    <div>
                        {{ $l10n.__('Pour modifier la fréquence de paiement,') }}<br />
                        {{ $l10n.__('merci de contacter un commercial') }}
                    </div>
                </template>
                <el-radio-button
                    label="YEARLY"
                    :disabled="disableYearly || isSourceSale"
                    class="prelative"
                >
                    <p class="m-0 px-2">
                        <span class="fs-3 pb-1 semibold block">
                            {{ $l10n.__('Payer en une fois') }}
                        </span>
                        <span class="fs-2 regular block">{{ $l10n.__('Économisez 17%') }} 🎉</span>
                    </p>
                </el-radio-button>
            </el-tooltip>
        </el-radio-group>
    </el-form-item>
</template>

<script>
export default {
    props: {
        store: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            baseRecurrency: null,
        };
    },
    computed: {
        isRenew() {
            return this.$store.getters[`${this.store}Cart/isRenew`];
        },
        isSourceSale() {
            return this.$store.getters[`${this.store}Cart/isSourceSale`];
        },
        recurrencies() {
            return this.$store.getters[`${this.store}Cart/recurrencies`];
        },
        recurrency() {
            return this.$store.getters[`${this.store}Cart/recurrency`];
        },
        isMonthly() {
            return this.$store.getters[`${this.store}Cart/isMonthly`];
        },
        isYearly() {
            return this.$store.getters[`${this.store}Cart/isYearly`];
        },
        recurrencyPlan: {
            get() {
                return this.recurrency;
            },
            set(value) {
                if (!this.baseRecurrency) this.baseRecurrency = this.recurrency;
                this.$store.dispatch(`${this.store}Cart/updateRecurrency`, value);
            },
        },
        disableYearly() {
            return this.isSourceSale && this.isMonthly && this.baseRecurrency !== 'YEARLY';
        },
    },
};
</script>
